export const en = {
  // Meta Tags
  meta: {
    title: 'Qingdao CTL Testing Laboratory ISO 17025 Testing Services',
    description: 'ILAC recognized internationally accredited testing laboratory. Specialized in European and US hazardous substance regulation testing and analysis for fashion jewelry, baby products, and general merchandise. ISO/IEC 17025 certified. Providing hazardous substance testing, children\'s product safety testing, and conformity assessment services.',
    keywords: 'testing laboratory, hazardous substance testing, children product safety, ISO 17025, ILAC recognition, fashion jewelry analysis',
    ogTitle: 'ISO 17025 Testing Laboratory - Internationally Accredited Testing Lab',
    ogDescription: 'ILAC recognized internationally accredited testing laboratory. Specialized in hazardous substance testing and analysis'
  },

  // Navigation
  nav: {
    home: 'Home',
    about: 'About Us',
    services: 'Services',
    certifications: 'Certifications',
    equipment: 'Equipment',
    virtualTour: 'Virtual Tour',
    resources: 'Resources',
    contact: 'Contact',
    business: 'Main Business',
    testingAnalysis: 'Testing/Analysis',
    productTesting: 'Product Testing Evaluation',
    certificationMark: 'Certification Business/Certification Mark',
    customerSupport: 'Customer & Technical Support',
    industrySolutions: 'Industry Solutions',
    certificationSupport: 'Certification System Support (By Field)',
    technicalCenter: 'Technical Center (Affiliated)',
    jewelry: 'Jewelry',
    childrenBaby: 'Children & Baby Products',
    educationCenter: 'Education Center',
    regulationResearch: 'Regulation Research/Standard Development',
    equipmentCertifications: 'Equipment/Certifications',
    announcements: 'Announcements',
    location: 'Directions',
    ceoMessage: 'CEO Message',
    managementPolicy: 'Management Policy',
    companyInfo: 'Company Introduction',
    companyHistory: 'Company History',
    organization: 'Organization'
  },

  // Company submenu
  company: {
    info: 'Company Info',
    ceoMessage: 'CEO Message',
    history: 'Company History'
  },

  // Company Info Page
  companyInfo: {
    badge: 'Company Info',
    title: 'Company Introduction',
    subtitle: 'An internationally accredited testing laboratory supporting customer success with trust and expertise',
    
    mainTitle: 'CTL (Qingdao CTL Testing Technology Service Co., Ltd.)',
    paragraph1: 'CTL was officially established in 2012 and obtained CNAS and ILAC international accreditation in 2017, making it a professional testing and inspection organization.',
    paragraph2: 'CTL provides testing and inspection services in various consumer goods sectors including fashion jewelry, toys, electronic and electrical products, textiles, and leather. We have established a global service network covering Europe, the United States, Japan, Korea, China, and other regions worldwide. Additionally, through strategic cooperation with major e-commerce platforms in China, we contribute to improving quality competitiveness across industries.',
    paragraph3: 'Based on international-level advanced testing equipment and skilled professional technical personnel, CTL strictly complies with domestic and international testing standards and regulations under the service philosophy of scientific fairness, accuracy, and efficiency.',
    paragraph4: 'We not only provide reliable testing and inspection reports to customers but also support global market entry and smooth product distribution through testing analysis and technical support for safety and environmental regulatory requirements of various countries.',
    paragraph5: 'CTL aims to be a core partner that grows together throughout the entire process of corporate material development and quality management.',
    
    tag1: 'CNAS Accredited',
    tag2: 'ILAC MRA Member',
    tag3: 'Internationally Recognized',
    
    missionTitle: 'Our Mission',
    missionDesc: 'We support our customers\' products to be safely distributed in global markets through the highest level of testing and analysis services, and contribute to protecting consumer health and safety.',
    
    visionTitle: 'Our Vision',
    visionDesc: 'To grow as Asia\'s leading testing and analysis organization, lead global quality standards, and become an industry benchmark through continuous innovation and development.',
    
    valuesTitle: 'Core Values',
    value1Title: 'Accuracy',
    value1Desc: 'Earning customer trust through precise analysis and reliable results',
    value2Title: 'Expertise',
    value2Desc: 'Providing the best service based on extensive experience and professional knowledge',
    value3Title: 'Speed',
    value3Desc: 'Saving customer time through rapid test processing and report issuance',
    value4Title: 'Customer Focus',
    value4Desc: 'Prioritizing customer satisfaction and providing continuous support',
    companyName: 'Qingdao Testing Technology Service Co., Ltd.',
    
    stat1: '2015',
    stat1Label: 'Year Established',
    stat2: '50+',
    stat2Label: 'Professional Staff',
    stat3: '10,000+',
    stat3Label: 'Annual Tests',
    stat4: '30+',
    stat4Label: 'Partner Countries',
    
    ctaTitle: 'Need More Information?',
    ctaDesc: 'Our professional consultants will quickly review your requirements and propose the best solution',
    contactButton: 'Contact Us',
    servicesButton: 'View Services'
  },

  // CEO Message Page
  ceoMessage: {
    badge: 'CEO Message',
    title: 'Message from CTL',
    subtitle: 'Creating Global Trust in Testing Standards',
    greeting: 'CTL is an accredited testing and analytical laboratory operating in accordance with the ISO/IEC 17025 international standard, and holds CNAS accreditation with ILAC MRA international recognition.',
    paragraph1: 'With state-of-the-art testing and analytical equipment and a team of highly experienced professionals, CTL provides accurate and reliable testing and inspection services. Our test results and reports are widely recognized across major countries and global markets.',
    paragraph2: 'Through efficient testing processes and systematic report issuance, we help our clients save valuable time while consistently delivering the highest level of quality at reasonable cost. In addition, we support our clients\' sustainable growth through continuous technical support and professional consulting services.',
    promiseTitle: 'Core Values',
    promise1: 'Scientific impartiality',
    promise2: 'Accuracy',
    promise3: 'Efficiency',
    promise4: 'Active support for safety and environmental regulations worldwide',
    paragraph3: 'CTL is not merely a provider of test results. Our goal is to become a trusted partner that supports the safe and smooth circulation of our clients\' products in the global market. We firmly believe that our clients\' success is our success, and we are fully committed to this principle in all that we do.',
    paragraph4: 'Based on continuous research and expertise in country-specific product regulations, CTL upholds scientific impartiality, accuracy, and efficiency as its core values, actively supporting compliance with international safety and environmental regulations. In particular, for Jewelry, Children\'s Products, and a wide range of Consumer Goods, CTL provides continuous support as a long-term global partner—from the product development stage through safe entry and distribution in global markets.',
    paragraph5: 'Moving forward, CTL will continue to advance through ongoing technological development and quality innovation, growing beyond Asia to become a globally leading testing and analytical institution. We sincerely appreciate your continued interest and support.',
    closing: 'Thank you.',
    ceoName: 'Jaemyung Kim',
    ceoTitle: 'Chief Executive Officer',
    companyName: 'CTL (Qingdao CTL Testing & Technical Services Co., Ltd.)',
    philosophyTitle: 'Management Philosophy',
    value1Title: 'Scientific Impartiality',
    value1Desc: 'Earning customer trust through accurate and fair test results',
    value2Title: 'Accuracy',
    value2Desc: 'Providing reliable testing and analysis with the finest professional personnel and equipment',
    value3Title: 'Efficiency',
    value3Desc: 'Being a partner dedicated to customer success with rapid, systematic service',
    ctaTitle: 'Need Testing and Analysis Services?',
    ctaDescription: 'Our professional consultants will quickly review your requirements and propose the best solution',
    contactButton: 'Contact Us',
    servicesButton: 'View Services',
    backToHome: 'Back to Home'
  },

  // Management Policy Page
  managementPolicy: {
    badge: 'Management Policy',
    title: 'Management Policy',
    subtitle: 'Our management philosophy and policies for customer satisfaction and quality priority',
    
    // Vision
    visionTitle: 'Management Vision',
    visionDescription: 'As a leading company in the global testing and certification field, we support customer success and contribute to industrial development based on the highest level of technology and reliability.',
    visionPoint1: 'Compliance with international standards and continuous quality improvement',
    visionPoint2: 'Providing customer-centered customized services',
    visionPoint3: 'Technology innovation and expertise enhancement',
    
    // Mission
    missionTitle: 'Management Mission',
    missionDescription: 'We guarantee product safety and quality through accurate and reliable testing services, and actively support customers\' entry into global markets.',
    missionPoint1: 'ISO/IEC 17025-based testing quality assurance',
    missionPoint2: 'Providing rapid and accurate test results',
    missionPoint3: 'Professional technical consulting and support',
    
    // ESH Social Responsibility
    eshTitle: 'Environmental, Safety & Health Social Responsibility',
    eshSubtitle: 'We practice socially responsible management that prioritizes environmental protection, workplace safety, and employee health.',
    
    environmentTitle: 'Environmental Protection and Sustainability',
    environmentPoint1: 'Introduction of eco-friendly testing methods and equipment',
    environmentPoint2: 'Minimization of chemicals and waste',
    environmentPoint3: 'Energy efficiency and carbon emission reduction',
    environmentPoint4: 'Compliance with ISO 14001 environmental management system',
    
    safetyTitle: 'Workplace Safety Management',
    safetyPoint1: 'Regular safety education and training',
    safetyPoint2: 'Provision and management of personal protective equipment',
    safetyPoint3: 'Compliance with safety procedures for handling hazardous materials',
    safetyPoint4: 'Accident prevention system and emergency response system',
    
    healthTitle: 'Employee Health Promotion',
    healthPoint1: 'Regular health checkups and special health examinations',
    healthPoint2: 'Work environment measurement and improvement',
    healthPoint3: 'Musculoskeletal disorder prevention program',
    healthPoint4: 'Employee welfare and health promotion programs',
    
    // Core Management Policies
    corePoliciesTitle: 'Core Management Policies',
    corePoliciesSubtitle: 'We comply with ISO/IEC 17025 international standards and provide the highest level of testing services through continuous quality improvement.',
    
    qualityFirstTitle: 'Quality First',
    qualityFirstDesc: 'We comply with ISO/IEC 17025 international standards and provide the highest level of testing services through continuous quality improvement.',
    
    customerSatisfactionTitle: 'Customer Satisfaction',
    customerSatisfactionDesc: 'We accurately understand customer requirements and realize customer satisfaction through rapid and accurate services.',
    
    expertiseTitle: 'Expertise Enhancement',
    expertiseDesc: 'We cultivate professional personnel through continuous education and training, and acquire the latest technologies and knowledge.',
    
    environmentalTitle: 'Environmental Responsibility',
    environmentalDesc: 'We introduce environmentally friendly testing methods and strive for sustainable development.',
    
    innovationTitle: 'Technology Innovation',
    innovationDesc: 'We continuously improve testing capabilities by introducing cutting-edge equipment and technology.',
    
    globalCooperationTitle: 'Global Cooperation',
    globalCooperationDesc: 'We issue internationally recognized test reports through ILAC MRA recognition and build a global network.',
    
    // Quality Management System
    qmsTitle: 'Quality Management System',
    qmsSubtitle: 'We operate a systematic quality management system based on ISO/IEC 17025 to ensure the accuracy and reliability of testing.',
    
    documentManagementTitle: 'Document Management',
    documentManagementDesc: 'Systematic document management system',
    
    personnelManagementTitle: 'Personnel Management',
    personnelManagementDesc: 'Professional personnel training and qualification management',
    
    equipmentManagementTitle: 'Equipment Management',
    equipmentManagementDesc: 'Regular calibration and maintenance',
    
    dataManagementTitle: 'Data Management',
    dataManagementDesc: 'Accurate data recording and analysis'
  },

  // Footer
  footer: {
    quickLinks: 'Quick Links',
    services: 'Our Services',
    contact: 'Contact Info',
    copyright: '© 2024 Qingdao CTL Testing Laboratory. All rights reserved.',
    poweredBy: 'Website Builder'
  },

  // Hero Section
  hero: {
    // Main titles for each slide
    slide1Title: 'Advanced Chemical Analysis',
    slide2Title: 'Comprehensive Product Safety Testing',
    slide3Title: 'Research & Development Support',
    slide4Title: 'Environmental Certification & Carbon Footprint',

    // Detailed content for left side text
    slide1MainTitle: 'ISO/IEC 17025 Certified Third-Party Accredited Testing Laboratory',
    slide1Point1: 'Based on accurate analytical data',
    slide1Point1Text: 'Based on accurate analytical data',
    slide1Point2: 'we provide highly reliable test reports and certificates.',
    slide1Point2Text: 'we provide highly reliable test reports and certificates.',

    slide2MainTitle: 'Highest Level of Technical Standards and Professional Engineers',
    slide2Point1: 'Strict product certification standards considering safety/hygiene environment',
    slide2Point1Text: 'Strict product certification standards considering safety/hygiene environment',
    slide2Point2: 'Professional evaluation services accumulated through long experience',
    slide2Point2Text: 'Professional evaluation services accumulated through long experience',
    slide2Point3: 'Testing and certification institution trusted by customers and the market',
    slide2Point3Text: 'Testing and certification institution trusted by customers and the market',

    slide3MainTitle: 'R&D & Technical Services',
    slide3Point1: 'Technical solutions for defect analysis',
    slide3Point1Text: 'Technical solutions for defect analysis',
    slide3Point2: 'Support from material selection to finished products',
    slide3Point2Text: 'Support from material selection to finished products',
    slide3Point3: 'A trusted testing and certification partner',
    slide3Point3Text: 'A trusted testing and certification partner',

    slide4MainTitle: 'Environmental Certification & Sustainability',
    slide4Point1: 'carbon footprint assessment',
    slide4Point1Text: 'We provide comprehensive ',
    slide4Point2: 'environmental impact evaluation',
    slide4Point2Text: 'Our services include detailed ',
    slide4Point3: 'Sustainable Development Goals: ',
    slide4Point3Text: 'We help companies achieve their sustainability targets and comply with international environmental standards.',

    // Product names for slider
    product1: 'Jewelry/Fashion Accessories',
    product2: 'Toys/Baby Products',
    product3: 'Baby Clothing',
    product4: 'Earrings',
    product5: 'Baby Pillow',
    product6: 'LEGO Spike',
    product7: 'Sliver safety Equipment',
    product8: 'Gold Bracelet',
    product9: 'Bicycle Helmet',
    product10: 'Gear Wheel',
    product11: 'Stationery',
    product12: 'Textile/Leather Products',
    product13: 'Furniture/Interior Decoration',
    product14: 'Tableware/Food Container',
    product15: 'Packaging/Transportation',
    product16: 'Inspection/Site Testing',

    // Equipment
    equipment1Name: 'GC-MS',
    equipment1Desc: 'Agilent Technologies Gas Chromatography-Mass Spectrometry. Used for organic compound analysis and trace component detection.',
    equipment1App1: 'Organic compound analysis',
    equipment1App2: 'Volatile substance detection',
    equipment1App3: 'Environmental pollutant analysis',
    equipment2Name: 'Equipment 2',
    equipment2Desc: 'Description of the second equipment. The actual equipment information will be updated after uploading photos.',
    equipment2App1: 'Application Area 1',
    equipment2App2: 'Application Area 2',
    equipment2App3: 'Application Area 3',
    equipment3Name: 'Equipment 3',
    equipment3Desc: 'Rayleigh UV-1801 UV/Visible Spectrophotometer. Used for absorbance measurement and concentration analysis of substances.',
    equipment3App1: 'Absorbance measurement',
    equipment3App2: 'Concentration analysis',
    equipment3App3: 'Qualitative/quantitative analysis of substances',
    equipment4Name: 'Equipment 4',
    equipment4Desc: 'Description of the fourth equipment. The actual equipment information will be updated after uploading photos.',
    equipment5Name: 'Equipment 5',
    equipment5Desc: 'Description of the fifth equipment. The actual equipment information will be updated after uploading photos.',
    equipment6Name: 'Equipment 6',
    equipment6Desc: 'Description of the sixth equipment. The actual equipment information will be updated after uploading photos.',
    equipment7Name: 'Equipment 7',
    equipment7Desc: 'ETHOS EASY Microwave Digestion System. Advanced equipment for sample pretreatment and digestion work.',
    equipment7App1: 'Sample pretreatment',
    equipment7App2: 'Microwave digestion',
    equipment7App3: 'Metal analysis pretreatment',
    equipment8Name: 'Equipment 8',
    equipment8Desc: 'Muffle Furnace - High Temperature Laboratory Furnace. Essential equipment for sample ashing, heat treatment, and high-temperature experiments.',
    equipment8App1: 'Sample ashing',
    equipment8App2: 'High-temperature heat treatment',
    equipment8App3: 'Ash content measurement',
    equipment9Name: 'Equipment 9',
    equipment9Desc: 'Description of the ninth equipment. The actual equipment information will be updated after uploading photos.',
    equipment10Name: 'Equipment 10',
    equipment10Desc: 'Description of the tenth equipment. The actual equipment information will be updated after uploading photos.',
    equipment11Name: 'Equipment 11',
    equipment11Desc: 'Description of the eleventh equipment. The actual equipment information will be updated after uploading photos.',
    equipment12Name: 'Equipment 12',
    equipment12Desc: 'Description of the twelfth equipment. The actual equipment information will be updated after uploading photos.',
    equipment13Name: 'Equipment 13',
    equipment13Desc: 'Description of the thirteenth equipment. The actual equipment information will be updated after uploading photos.',
    equipment14Name: 'Equipment 14',
    equipment14Desc: 'Description of the fourteenth equipment. The actual equipment information will be updated after uploading photos.',
    equipment15Name: 'Equipment 15',
    equipment15Desc: 'COX EM-30AX Advanced Analytical System. Advanced equipment for precision analysis and measurement.',
    equipment15App1: 'Precision analysis',
    equipment15App2: 'Component measurement',
    equipment15App3: 'Quality management',
    equipment16Name: 'Equipment 16',
    equipment16Desc: 'Description of the sixteenth equipment. The actual equipment information will be updated after uploading photos.',
    equipment17Name: 'Equipment 17',
    equipment17Desc: 'Description of the seventeenth equipment. The actual equipment information will be updated after uploading photos.',
    equipment18Name: 'Equipment 18',
    equipment18Desc: 'Vision Inspection System. Precision inspection equipment used for product appearance inspection and quality management.',
    equipment18App1: 'Appearance inspection',
    equipment18App2: 'Quality management',
    equipment18App3: 'Defect detection',
    equipment19Name: 'Equipment 19',
    equipment19Desc: 'X-ray Fluorescence Analyzer (XRF). Precision equipment for non-destructive analysis of material elemental composition.',
    equipment19App1: 'Elemental analysis',
    equipment19App2: 'Non-destructive testing',
    equipment19App3: 'Metal composition analysis',
    equipment20Name: 'Equipment 20',
    equipment20Desc: 'Description of the twentieth equipment. The actual equipment information will be updated after uploading photos.',
    equipment21Name: 'Equipment 21',
    equipment21Desc: 'Description of the twenty-first equipment. The actual equipment information will be updated after uploading photos.',

    title: 'Leading Testing Laboratory',
    subtitle: 'ISO/IEC 17025 Accredited | ILAC MRA Recognized',
    description: 'Providing world-class testing services with international recognition and reliability',
    cta: 'Start Testing',
    learnMore: 'Learn More',
    
    // Badge
    badge: 'ISO/IEC 17025 Certified',
    
    // Cards
    card1Title: 'ISO 17025 Certified',
    card1Desc: 'Internationally Accredited Laboratory Quality Management System',
    card2Title: 'Global Network',
    card2Desc: 'ILAC MRA Mutual Recognition Agreement Member',
    card3Title: 'Advanced Equipment',
    card3Desc: 'Latest Analytical Equipment and Professional Personnel',
    card4Title: 'Expert Team',
    card4Desc: 'Professional Group with Rich Experience',
    
    // Buttons
    btnServices: 'View Services',
    btnContact: 'Contact Us'
  },

  // About Section
  about: {
    badge: 'Company Introduction',
    title: 'CTL Introduction',
    subtitle: 'An internationally recognized testing organization that supports customer success with trust and expertise',
    mission: 'Our Mission',
    missionDesc: 'We support our customers\' products to be safely distributed in global markets through the highest level of testing and analysis services, and contribute to protecting consumer health and safety.',
    vision: 'Our Vision',
    visionDesc: 'To grow as Asia\'s leading testing and analysis organization, lead global quality standards, and become an industry benchmark through continuous innovation and development.',
    values: 'Core Values',
    value1: 'Accuracy',
    value1Desc: 'Earning customer trust through precise analysis and reliable results',
    value2: 'Expertise',
    value2Desc: 'Providing the best service based on extensive experience and professional knowledge',
    value3: 'Speed',
    value3Desc: 'Saving customer time through rapid test processing and report issuance',
    value4: 'Customer Focus',
    value4Desc: 'Prioritizing customer satisfaction and providing continuous support'
  },

  // History Section
  history: {
    badge: 'Company History',
    title: 'Our Growth Journey',
    subtitle: 'Introducing CTL\'s development history and major achievements',
    year2026: '2026 ~',
    event2026_1: 'Establishment of CTL Korea Branch and Vietnam Testing Laboratory (In progress)',
    year2018: '2018 ~',
    event2018_1: '4th expansion of accredited test scopes under ISO/IEC 17025',
    event2018_2: 'Service scope expanded to hazardous substances analysis and all categories of consumer products',
    year2017: '2017 ~',
    event2017_1: 'Designated as an ISO/IEC 17025 accredited testing laboratory [ILAC / CNAS]',
    event2017_2: 'Provision of accredited testing services to over 1,200 exporters and 30+ global buyers',
    year2016: '2016 ~',
    event2016_1: 'Signed a joint R&D cooperation agreement with the Korea Jewelry Research Institute (Surface treatment and related technologies)',
    year2014: '2014 ~',
    event2014_1: 'Signed an MOU with the China–Korea Crafts Association',
    year2012: '2012 ~',
    event2012_1: 'Establishment of an independent third-party corporate testing laboratory (Qingdao, China and Hong Kong)',
    year2008: '2008 ~',
    event2008_1: 'Support for the establishment of in-house second-party testing laboratories',
    event2008_2: 'Operation of a Central Testing Lab providing technical guidance to company-owned labs',
    year2007: '2007 ~',
    event2007_1: 'Development of an HSPM (Hazardous Substances Process Management) system in response to U.S. CPSIA and EU REACH regulations',
    event2007_2: 'Provision of regulatory and technical support to exporters and global buyers'
  },

  // Services Section (aligned with ZH content)
  services: {
    badge: 'Our Services',
    title: 'Comprehensive Testing Solutions',
    subtitle: 'Professional testing services covering chemical analysis, physical properties, and product safety',

    service1Title: 'Chemical Testing',
    service1Item1: 'Hazardous substance analysis',
    service1Item2: 'Metal/non-metal/material analysis',
    service1Item3: 'Polymer/fiber analysis',
    service1Item4: 'Hygiene testing for toys and other consumer products',
    service1Item5: 'Precious metals and jewelry product testing and analysis',

    service2Title: 'Physical Testing',
    service2Item1: 'Consumer product safety evaluation testing',
    service2Item2: 'Reliability testing',
    service2Item3: 'Surface treatment durability evaluation testing',
    service2Item4: 'Flammability testing for textile and electrical materials',
    service2Item5: 'Environmental fatigue testing',

    service3Title: 'Product Safety',
    service3Item1: 'Precious metals and jewelry product safety and quality evaluation',
    service3Item2: 'Safety evaluation for toys and other consumer products',
    service3Item3: 'Safety evaluation for household appliances',
    service3Item4: 'Evaluation of products related to domestic and international certifications',
    service3Item5: 'Complete packaging (internal/external) product evaluation',

    service4Title: 'System Certification & Certification Mark',
    service4Item1: 'Precious metals quality certification',
    service4Item2: 'HSPM – Hazardous substance process management',
    service4Item3: 'IATF16949 certification consulting',
    service4Item4: 'SAH safety and hygiene certification',
    service4Item5: 'Workplace environmental assessment',

    service5Title: 'Research and Development',
    service5Item1: 'Standard material development',
    service5Item2: 'Standard and specification formulation',
    service5Item3: 'Technical book publishing',

    service6Title: 'Enterprise Support',
    service6Item1: 'Education and training',
    service6Item2: 'Enterprise laboratory support and central laboratory operation',
    service6Item3: 'Certification acquisition consulting'
  },

  // Certifications Section
  certifications: {
    badge: 'Our Certifications',
    title: 'International Recognition',
    subtitle: 'Accredited by leading international organizations',
    iso17025: {
      title: 'ISO/IEC 17025',
      description: 'International standard for testing and calibration laboratories'
    },
    ilac: {
      title: 'ILAC MRA',
      description: 'International Laboratory Accreditation Cooperation Mutual Recognition Arrangement'
    },
    cnas: {
      title: 'CNAS Accreditation',
      description: 'China National Accreditation Service for Conformity Assessment'
    },
    cert1Title: 'ISO/IEC 17025 Certification',
    cert1Desc: 'Internationally recognized laboratory quality management system ensuring accuracy and reliability of testing and calibration results.',
    cert1Tag1: 'International Standard',
    cert1Tag2: 'Quality Assurance',
    cert1Tag3: 'Reliability',
    cert2Title: 'ILAC MRA Recognition',
    cert2Desc: 'International Laboratory Accreditation Cooperation Mutual Recognition Arrangement, ensuring global acceptance of test results.',
    cert2Tag1: 'Global Recognition',
    cert2Tag2: 'Mutual Recognition',
    cert2Tag3: 'International Cooperation',
    cert3Title: 'US CPSC Recognition',
    cert3Desc: 'Passed US CPSC laboratory accreditation',
    cert3Tag1: 'CPSC Recognition',
    cert3Tag2: 'CPC Production',
    cert3Tag3: 'International Cooperation',
    region1: 'Europe',
    region2: 'USA',
    region3: 'Asia',
    region4: 'International'
  },

  // Equipment Section
  equipment: {
    badge: 'Our Equipment',
    title: 'State-of-the-Art Testing Equipment',
    subtitle: 'Advanced instrumentation for precise and reliable testing',
    
    equipment1Name: 'ICP-MS',
    equipment1FullName: 'Inductively Coupled Plasma Mass Spectrometry',
    equipment1Desc: 'Ultra-sensitive elemental analysis for trace metal detection in various sample matrices',
    equipment1App1: 'Heavy metals in toys',
    equipment1App2: 'Environmental samples',
    equipment1App3: 'Food contamination',

    equipment2Name: 'GC-MS',
    equipment2FullName: 'Gas Chromatography-Mass Spectrometry',
    equipment2Desc: 'Advanced organic compound identification and quantification system',
    equipment2App1: 'Volatile organic compounds',
    equipment2App2: 'Pesticide residues',
    equipment2App3: 'Fragrance analysis',

    equipment3Name: 'LC-MS/MS',
    equipment3FullName: 'Liquid Chromatography-Tandem Mass Spectrometry',
    equipment3Desc: 'High-precision analysis of complex organic molecules and pharmaceuticals',
    equipment3App1: 'Drug testing',
    equipment3App2: 'Food additives',
    equipment3App3: 'Environmental pollutants',

    equipment4Name: 'XRF Spectrometer',
    equipment4FullName: 'X-ray Fluorescence Spectrometer',
    equipment4Desc: 'Non-destructive elemental analysis for rapid material identification',
    equipment4App1: 'Metal alloy analysis',
    equipment4App2: 'RoHS screening',
    equipment4App3: 'Coating thickness',

    equipment5Name: 'FTIR',
    equipment5FullName: 'Fourier Transform Infrared Spectroscopy',
    equipment5Desc: 'Molecular structure analysis and material identification',
    equipment5App1: 'Polymer identification',
    equipment5App2: 'Additive analysis',
    equipment5App3: 'Quality control',

    equipment6Name: 'Universal Testing Machine',
    equipment6FullName: 'Universal Tensile Testing Machine',
    equipment6Desc: 'Mechanical property testing for materials and products',
    equipment6App1: 'Tensile strength',
    equipment6App2: 'Compression testing',
    equipment6App3: 'Flexural properties',

    equipment7Name: 'Environmental Chamber',
    equipment7FullName: 'Temperature Humidity Testing Chamber',
    equipment7Desc: 'Controlled environment testing for product reliability',
    equipment7App1: 'Climate simulation',
    equipment7App2: 'Aging tests',
    equipment7App3: 'Durability assessment',

    equipment8Name: 'Microscopy System',
    equipment8FullName: 'Advanced Optical Microscopy System',
    equipment8Desc: 'High-resolution imaging and morphological analysis',
    equipment8App1: 'Microstructure analysis',
    equipment8App2: 'Particle characterization',
    equipment8App3: 'Surface defect inspection',

    equipment9Name: 'Combustion Tester',
    equipment9FullName: 'Flammability Testing Equipment',
    equipment9Desc: 'Safety testing for flammability and fire resistance',
    equipment9App1: 'Textile flammability',
    equipment9App2: 'Building materials',
    equipment9App3: 'Electronic products',

    equipment10Name: 'Hardness Tester',
    equipment10FullName: 'Multi-scale Hardness Testing System',
    equipment10Desc: 'Comprehensive hardness measurement across different scales',
    equipment10App1: 'Metal hardness',
    equipment10App2: 'Polymer testing',
    equipment10App3: 'Coating evaluation',

    equipment11Name: 'Particle Analyzer',
    equipment11FullName: 'Laser Particle Size Analyzer',
    equipment11Desc: 'Precise particle size distribution analysis',
    equipment11App1: 'Powder characterization',
    equipment11App2: 'Nanoparticle analysis',
    equipment11App3: 'Quality control',

    equipment12Name: 'Thermal Analyzer',
    equipment12FullName: 'Differential Scanning Calorimetry',
    equipment12Desc: 'Thermal properties and phase transition analysis',
    equipment12App1: 'Glass transition',
    equipment12App2: 'Melting point',
    equipment12App3: 'Thermal stability',

    equipment13Name: 'Ion Chromatograph',
    equipment13FullName: 'Ion Chromatography System',
    equipment13Desc: 'Ion analysis in aqueous solutions',
    equipment13App1: 'Water quality',
    equipment13App2: 'Food analysis',
    equipment13App3: 'Environmental monitoring',

    equipment14Name: 'UV-Vis Spectrometer',
    equipment14FullName: 'UV-Visible Spectrophotometer',
    equipment14Desc: 'Optical analysis and concentration determination',
    equipment14App1: 'Colorant analysis',
    equipment14App2: 'Concentration measurement',
    equipment14App3: 'Purity assessment',

    equipment15Name: 'Atomic Absorption',
    equipment15FullName: 'Atomic Absorption Spectrophotometer',
    equipment15Desc: 'Elemental analysis with high sensitivity',
    equipment15App1: 'Metal content',
    equipment15App2: 'Trace analysis',
    equipment15App3: 'Quality control',

    equipment16Name: 'NMR Spectrometer',
    equipment16FullName: 'Nuclear Magnetic Resonance Spectrometer',
    equipment16Desc: 'Molecular structure and dynamics analysis',
    equipment16App1: 'Structure elucidation',
    equipment16App2: 'Purity analysis',
    equipment16App3: 'Quantitative analysis',

    equipment17Name: 'Surface Profiler',
    equipment17FullName: 'Optical Surface Profiler',
    equipment17Desc: '3D surface topology and roughness measurement',
    equipment17App1: 'Surface roughness',
    equipment17App2: 'Coating thickness',
    equipment17App3: 'Wear analysis',

    equipment18Name: 'Rheometer',
    equipment18FullName: 'Rotational Rheometer',
    equipment18Desc: 'Viscosity and flow properties measurement',
    equipment18App1: 'Fluid analysis',
    equipment18App2: 'Polymer characterization',
    equipment18App3: 'Quality control',

    equipment19Name: 'Colorimeter',
    equipment19FullName: 'Precision Colorimeter',
    equipment19Desc: 'Color measurement and quality control',
    equipment19App1: 'Color matching',
    equipment19App2: 'Quality control',
    equipment19App3: 'Specification compliance',

    equipment20Name: 'Density Meter',
    equipment20FullName: 'Digital Density Meter',
    equipment20Desc: 'Precise density and specific gravity measurement',
    equipment20App1: 'Material identification',
    equipment20App2: 'Quality control',
    equipment20App3: 'Concentration analysis',

    equipment21Name: 'Salt Spray Tester',
    equipment21FullName: 'Corrosion Testing Chamber',
    equipment21Desc: 'Corrosion resistance testing for materials and coatings',
    equipment21App1: 'Coating durability',
    equipment21App2: 'Metal corrosion',
    equipment21App3: 'Product lifetime',

    viewDetails: 'View Details',
    applications: 'Applications',
    applicationsLabel: 'Main Application Areas:'
  },

  // 360 Viewer
  viewer360: {
    dragInstruction: 'Drag with mouse to rotate 360 degrees',
    drag: 'Drag',
    scroll: 'Scroll',
    autoRotate: 'Auto Rotate'
  },

  // Virtual Tour Section
  virtualTour: {
    badge: 'Virtual Tour',
    title: 'Explore Our Laboratory',
    subtitle: 'Take a 360° virtual tour of our state-of-the-art testing facilities',
    
    videoTitle: 'Laboratory Introduction Video',
    videoDescription: 'Watch our comprehensive laboratory introduction video showcasing our advanced testing capabilities, expert team, and commitment to quality.',
    
    labChemical: 'Chemical Analysis Lab',
    labPhysical: 'Physical Testing Lab',
    labMicrobiology: 'Microbiology Lab',
    meetingRoom: 'Meeting & Consultation Room',
    
    qingdaoSubway: 'Qingdao Subway Map',
    qingdaoSubwayDesc: 'Our laboratory is conveniently located with easy access via Qingdao Metro system. Click to explore the subway map and plan your visit.',
    
    startTour: 'Start Virtual Tour',
    location: 'Our Location',
    view360: '360° View',
    tourExperience: '360° Virtual Tour Experience',
    tourExperienceDesc: 'Drag with your mouse to explore the laboratory interior in 360 degrees. Experience it as vividly as an actual visit.'
  },

  // Resources Section
  resources: {
    badge: 'Resources Center',
    title: 'Testing Resources & Documentation',
    subtitle: 'Comprehensive collection of testing guides, certificates, and regulatory information',
    
    testGuides: 'Test Guides',
    testGuidesDesc: 'Comprehensive testing methodologies and procedures',
    chemicalGuide: 'Chemical Testing Guide',
    physicalGuide: 'Physical Testing Guide',
    qualityGuide: 'Quality Assurance Manual',
    
    certificateSamples: 'Certificate Samples',
    certificateSamplesDesc: 'Sample certificates and accreditation documents',
    iso17025: 'ISO/IEC 17025 Certificate',
    testReportSample: 'Test Report Sample',
    ilacCert: 'ILAC MRA Certificate',
    
    testReportForms: 'Test Report Forms',
    testReportFormsDesc: 'Standard forms and templates for test reporting',
    testRequestForm: 'Test Request Form',
    sampleSubmissionForm: 'Sample Submission Form',
    reportTemplate: 'Report Template',
    
    regulatoryDocs: 'Regulatory Documentation',
    regulatoryDocsDesc: 'Important regulatory standards and guidelines',
    ilacGuide: 'ILAC Guidelines',
    ksStandards: 'KS Standards',
    
    trainingMaterials: 'Training Materials',
    trainingMaterialsDesc: 'Educational resources and training materials',
    testMethodTraining: 'Test Method Training',
    qualityManual: 'Quality Management Manual',
    safetyTraining: 'Laboratory Safety Training',
    
    downloadCenter: 'Download Center',
    downloadCenterDesc: 'Software tools and technical documents',
    dataAnalysisTool: 'Data Analysis Tool',
    reportViewer: 'Report Viewer',
    technicalPaper: 'Technical Papers',
    
    download: 'Download',
    needHelp: 'Can\'t find what you\'re looking for?',
    needHelpDesc: 'Our technical support team is here to help you find the resources you need.',
    contactUs: 'Contact Us'
  },

  // Announcements Page
  announcements: {
    badge: 'Announcements',
    title: 'Announcements',
    subtitle: 'No announcements at the moment',
    backToHome: 'Back to Home',
    emptyTitle: 'No Announcements',
    emptyDesc: 'There are no announcements at the moment. Please check back later.'
  },

  // Location Section
  location: {
    badge: 'Directions',
    title: 'Visit Our Laboratory',
    subtitle: 'Convenient transportation for your visit',
    address: 'Qingdao High-tech Industrial Development Zone, Shandong Province, China',
    phone: '+86 532 8888 9999',
    email: 'info@qingdaolab.com',
    hours: 'Monday - Friday: 8:00 AM - 6:00 PM',
    directions: 'Get Directions',
    subway: 'Subway Access',
    subwayLine: 'Qingdao Metro Line 1',
    subwayDesc: '5 minutes walk from High-tech Zone Station',
    subwayStation: 'High-tech Zone Station',
    subwayTime: '5 minutes walk from station',
    subwayMapInstructions: 'Click and drag to explore the subway map. Scroll to zoom in/out.',
    subwayMapHelp: 'Click on the map to zoom in and explore subway routes.',
    subwayMapLink: 'Click to view Qingdao Subway Map',
    car: 'Self-Driving',
    carParking: 'Free Parking',
    carDesc: '',
    bus: 'Bus',
    busLines: 'Routes 111, 131, 946, 4201',
    busDesc: 'Get off at Taipingzhuang Station, 900m west'
  },

  // Contact Section
  contact: {
    badge: 'Contact Us',
    title: 'Get in Touch',
    subtitle: 'Ready to start your testing project? Contact our expert team today.',
    
    form: {
      name: 'Full Name',
      email: 'Email Address',
      company: 'Company Name',
      phone: 'Phone Number',
      service: 'Service Type',
      message: 'Message',
      submit: 'Send Message',
      
      services: {
        chemical: 'Chemical Analysis',
        physical: 'Physical Testing',
        safety: 'Product Safety',
        environmental: 'Environmental Testing',
        textile: 'Textile Testing',
        food: 'Food Safety',
        other: 'Other'
      }
    },
    
    infoTitle: 'Contact Information',
      phone: 'Phone',
      email: 'Email',
    address: 'Address',
    addressLine1: '',
    addressLine2: 'Room 301, Building 1, No. 57 Shuyun East Road, Chengyang District, Qingdao City',
      hours: 'Business Hours',
    hoursWeekday: 'Monday - Friday: 08:00-18:00',
    hoursWeekend: 'Saturday: 08:00-14:00',
    
    quickTitle: 'Quick Consultation',
    quickDesc: 'Have urgent inquiries? Please contact us by phone directly.',
    quickPhone: 'Consultation Phone',
    
    formTitle: 'Inquiry Form',
    formName: 'Name',
    formCompany: 'Company Name',
    formEmail: 'Email',
    formPhone: 'Phone Number',
    formService: 'Service Type',
    formServicePlaceholder: 'Please select a service',
    formServiceOption1: 'Chemical Analysis',
    formServiceOption2: 'Physical Testing',
    formServiceOption3: 'Product Safety',
    formServiceOption4: 'Environmental Testing',
    formServiceOption5: 'Textile Testing',
    formServiceOption6: 'Food Safety',
    formServiceOption7: 'Other',
    formMessage: 'Inquiry Content',
    formMessagePlaceholder: 'Please enter your inquiry content (max 500 characters)',
    formSubmit: 'Submit Inquiry',
    formSuccess: 'Inquiry submitted successfully!',
    formError: 'An error occurred while submitting the inquiry. Please try again.'
  },

  // Common
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success',
    readMore: 'Read More',
    learnMore: 'Learn More',
    getStarted: 'Get Started',
    contactUs: 'Contact Us',
    viewAll: 'View All',
    backToHome: 'Back to Home'
  },

  // Business Page
  business: {
    badge: 'Main Business',
    title: 'Main Business',
    subtitle: 'Introducing CTL\'s diverse business areas.',
    backToHome: 'Back to Home',
    laboratoryName: 'ISO 17025 Testing Laboratory',
    laboratoryDesc: 'ILAC Accredited Testing Services',
    col1Header: 'Test Analysis',
    col2Header: 'Product Suitability Evaluation',
    col3Header: 'Product Inspection',
    col4Header: 'System Certification & Certification Mark',
    col5Header: 'Research & Development',
    col6Header: 'Enterprise Support',
    ctaTitle: 'Main Business Inquiry',
    ctaDesc: 'Our professional consultants will quickly review your requirements and propose the best solution.',
    ctaPhone: 'Customer Service',
    tableData: [
      { rowHeader: 'Material/Raw Material Analysis', col1: ['Fashion & Jewelry Products'], col2: ['Product Quality Inspection'], col3: ['SA-8000'], col4: ['Standard Material Development'], col5: ['Education & Training'] },
      { rowHeader: 'Hazardous Substance Analysis', col1: ['Toys, Infant Products, Stationery'], col2: ['Factory Audit'], col3: ['HSPM'], col4: ['Standard & Specification Development'], col5: ['Consulting Support'] },
      { rowHeader: 'Polymer Materials', col1: ['Sanitary Products'], col2: ['On-site Testing and Inspection'], col3: ['ISO9000/140000'], col4: ['Technical Book Publication'], col5: [] },
      { rowHeader: 'Precious Metal Material Analysis', col1: ['Textiles'], col2: [], col3: ['IATF-16949 Certification Consulting'], col4: [], col5: [] },
      { rowHeader: 'Metal/Non-metal/Minerals', col1: ['Elderly Safety Products'], col2: [], col3: ['SAH Safety and Health Certification'], col4: [], col5: [] },
      { rowHeader: 'Surface Treatment/Plating Solution Analysis', col1: ['Environmental/Safety/Health Products'], col2: [], col3: ['Precious Metal Quality Certification'], col4: [], col5: [] },
      { rowHeader: 'Fiber Material and Physical Property Testing', col1: ['Automotive Electronic & Electrical Component Testing'], col2: [], col3: ['Workplace Environmental Assessment'], col4: [], col5: [] },
      { rowHeader: 'Physical Strength and Fatigue Testing', col1: ['Household Appliances'], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: 'Reliability Testing', col1: ['Complete Packaging (Internal/External) Product Evaluation'], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: 'Consumer Goods Related Testing', col1: ['Domestic and International Certification Related Product Evaluation'], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: 'Environmental Health Related Testing and Analysis', col1: ['Product Defect Cause Analysis and Evaluation'], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: 'Packaging Material Testing', col1: [], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: 'Electronic Component Testing', col1: [], col2: [], col3: [], col4: [], col5: [] },
      { rowHeader: 'Microorganism Testing', col1: [], col2: [], col3: [], col4: [], col5: [] }
    ]
  },

  // Testing Analysis Page
  testingAnalysis: {
    badge: 'Main Business',
    title: 'Testing/Analysis Items',
    subtitle: 'We provide accurate and reliable testing and analysis services at our ISO 17025 certified laboratory.',
    backToHome: 'Home',
    laboratoryName: 'ISO 17025 Testing Laboratory',
    laboratoryDesc: 'ILAC Accredited Testing Services',
    
    category1Title: 'Material/Raw Material Analysis',
    category1Items: ['Metal/Non-metal', 'Minerals', 'Polymers', 'Glass/Ceramic Materials', 'Precious Metal Analysis'],
    
    category2Title: 'Hazardous Substance Analysis',
    category2Items: [
      'Heavy Metals', 'Phthalates', 'pH', 'Formaldehyde', 'PAHs', 
      'Azo dyes', 'APEOs', 'Dimethylfumarate (DMFu or DMF)', 'BPA',
      'Carcinogenic dyes', 'Cr 6+', 'PCP', 'TeCP', 'Disperse dyes', 
      'Flame retardants', 'Nickel Release', 'Nitrosamines', 
      'Organictins', 'PFAS', 'Solvents'
    ],
    
    category3Title: 'Surface Treatment/Plating Solution Testing',
    category3Items: ['Gold/Silver', 'Precious Metal Content', 'Plating Solution Analysis'],
    
    category4Title: 'Physical Testing',
    category4Items: ['Tensile Strength', 'Hardness (HV)', 'Durability test'],
    
    category5Title: 'Textile Testing',
    category5Items: ['Flammability Test', '30+ Washing Tests', 'Material Identification'],
    
    category6Title: 'Reliability Testing',
    category6Items: ['Salt spray test', 'Environment ageing test', 'Wearable test', 'Light exposure test'],
    
    category7Title: 'Packaging Testing',
    category7Items: ['Transport Test', 'Drop Test', 'Bursting/Edge crush test'],
    
    ctaTitle: 'Testing Analysis Inquiry',
    ctaDesc: 'Our professional consultants will guide you through your testing and analysis requirements in detail.',
    ctaPhone: 'Customer Service'
  },

  // Certifications Page
  certificationsPage: {
    badge: 'Certifications',
    title: 'Certification Status',
    subtitle: 'Internationally recognized laboratory certifications and qualifications',
    backToHome: 'Home',
    
    iso17025Title: 'ISO/IEC 17025',
    iso17025Desc: 'We have obtained international standard certification for the competence of testing and calibration laboratories, ensuring the accuracy and reliability of test results internationally.',
    iso17025Tag1: 'International Standard',
    iso17025Tag2: 'Quality Assurance',
    iso17025Tag3: 'Reliability',
    
    ilacTitle: 'ILAC MRA',
    ilacDesc: 'As a member of the International Laboratory Accreditation Cooperation (ILAC) Mutual Recognition Arrangement, our test reports are recognized worldwide.',
    ilacTag1: 'Global Recognition',
    ilacTag2: 'Mutual Recognition',
    ilacTag3: 'International Cooperation',
    
    regionalTitle: 'Regional Certification Status',
    region1: 'European Regulations',
    region1Standards: ['REACH/UK REACH', 'ROHS/LVD Directives', 'GDPR/GPSR', 'Toy Safety Directives'],
    region2: 'USA Regulations',
    region2Standards: ['16 CFR CPSC/CPSIA', 'California & other State Law', '21CFR/29CFR', 'CPC/GPSC'],
    region3: 'Asia Regulations',
    region3Standards: ['GB & CCC', 'KS & KC/K-REACH', 'JIS & PSE/PSC', 'ASEAN Harmonized Standard'],
    region4: 'International Harmonized Regulations',
    region4Standards: ['IECEE CB Scheme', 'ISO/IEC', 'GHS', 'Codex Alimentarius'],
    
    certDetailsTitle: 'Certification Details',
    chemicalCertTitle: 'Chemical Testing Certification',
    chemicalCertItems: ['ICP-MS Analysis', 'GC-MS Analysis', 'LC-MS/MS Analysis', 'XRF Analysis'],
    
    physicalCertTitle: 'Physical Testing Certification',
    physicalCertItems: ['Mechanical Properties', 'Thermal Analysis', 'Electrical Testing', 'Dimensional Measurement'],
    
    safetyCertTitle: 'Product Safety Certification',
    safetyCertItems: ['Toy Safety', 'Textile Safety', 'Electronics Safety', 'Food Contact Materials'],
    
    envCertTitle: 'Environmental Testing Certification',
    envCertItems: ['RoHS', 'REACH', 'Phthalates', 'VOC'],
    
    microCertTitle: 'Microbiology Testing Certification',
    microCertItems: ['Bacteria Testing', 'Mold Testing', 'Yeast Testing', 'Pathogen Testing'],
    
    preciousCertTitle: 'Precious Metal Testing Certification',
    preciousCertItems: ['Gold Purity', 'Silver Purity', 'Platinum Purity', 'Diamond Appraisal'],
    
    // Actual Certificate Information
    actualCertsTitle: 'Our Certificates',
    cnasTitle: 'CNAS Certificate',
    cnasNumber: 'Certificate No: CNAS L10485',
    
    cpscCertTitle: 'CPSC Recognition',
    cpscCertNumber: 'Member No: 1698'
  },

  // Industry Solutions Page
  industrySolutions: {
    badge: 'Customer Support',
    title: 'Industry Solutions',
    subtitle: 'Professional testing, analysis, and certification solutions tailored to each industry sector',
    servicesProvided: 'Services Provided',
    ctaTitle: 'Need a Customized Solution?',
    ctaDesc: 'We offer optimal solutions tailored to your industry and product characteristics',
    ctaButton: 'Contact Us',
    jewelry: {
      title: 'Jewelry Industry',
      description: 'Comprehensive solutions for quality assurance and safety of precious metals and gemstone products',
      service1: 'Precious metal purity analysis (gold, silver, platinum, etc.)',
      service2: 'Gemstone appraisal and quality evaluation',
      service3: 'Hazardous substance testing (nickel, cadmium, lead, etc.)',
      service4: 'Physical safety testing',
      service5: 'International certification support (REACH, RoHS)'
    },
    children: {
      title: 'Children/Baby Products Industry',
      description: 'Professional testing and certification solutions prioritizing child and infant safety',
      service1: 'Physical safety testing (sharp edges, small parts)',
      service2: 'Chemical safety testing (phthalates, heavy metals)',
      service3: 'Flammability testing',
      service4: 'EN 71, ASTM F963, CPSIA certification support',
      service5: 'Product improvement consulting'
    },
    textile: {
      title: 'Textile/Apparel Industry',
      description: 'Professional testing services ensuring textile product quality and safety',
      service1: 'Fiber composition analysis',
      service2: 'Color fastness testing',
      service3: 'Hazardous substance testing (azo dyes, formaldehyde)',
      service4: 'Physical performance testing (strength, durability)',
      service5: 'Oeko-Tex Standard 100 certification support'
    },
    cosmetics: {
      title: 'Cosmetics Industry',
      description: 'Professional analysis services verifying cosmetic safety and efficacy',
      service1: 'Microbial testing (total count, E. coli, Pseudomonas)',
      service2: 'Heavy metal analysis (lead, arsenic, mercury)',
      service3: 'Preservative and additive analysis',
      service4: 'Skin irritation testing',
      service5: 'ISO 22716 (GMP) certification support'
    },
    food: {
      title: 'Food Industry',
      description: 'Comprehensive analysis services ensuring food safety and quality',
      service1: 'Nutritional analysis',
      service2: 'Microbial testing',
      service3: 'Pesticide residue testing',
      service4: 'Heavy metal analysis',
      service5: 'HACCP, ISO 22000 certification support'
    },
    electronics: {
      title: 'Electronics/Electrical Industry',
      description: 'Professional testing services verifying electronic product safety and performance',
      service1: 'Electrical safety testing',
      service2: 'Hazardous substance testing (RoHS, REACH)',
      service3: 'EMC testing (electromagnetic compatibility)',
      service4: 'Battery safety testing',
      service5: 'CE, FCC certification support'
    },
    packaging: {
      title: 'Packaging Industry',
      description: 'Professional services verifying packaging safety and environmental friendliness',
      service1: 'Food contact material testing',
      service2: 'Heavy metal migration testing',
      service3: 'Physical performance testing',
      service4: 'Biodegradability testing',
      service5: 'FDA, EU regulation compliance assessment'
    },
    medical: {
      title: 'Medical Device Industry',
      description: 'Professional testing services verifying medical device safety and efficacy',
      service1: 'Biocompatibility testing',
      service2: 'Sterilization validation',
      service3: 'Physical/mechanical performance testing',
      service4: 'Electrical safety testing',
      service5: 'ISO 13485, CE certification support'
    }
  },

  // Product Testing Page
  productTesting: {
    badge: 'Main Business',
    title: 'Product Conformity Assessment',
    subtitle: 'Providing professional testing and evaluation services for various product groups. Ensuring accurate and reliable test results according to international standards.',
    backToHome: 'Back to Home',
    companyName: 'Qingdao Testing Technology Service Co., Ltd.',
    categoriesTitle: 'Product Categories',
    categoriesSubtitle: 'Providing specialized testing services for each product group',
    whyTitle: 'Why Choose Us?',
    whySubtitle: 'Providing the highest level of testing services based on expertise and reliability',
    processTitle: 'Testing Process',
    processSubtitle: 'Providing accurate test results through systematic processes',
    ctaTitle: 'Need Testing Consultation?',
    ctaDesc: 'Professional consultants will guide you on the optimal testing method for your product.',
    ctaButton1: 'Online Inquiry',
    ctaButton2: 'Phone Inquiry',
    ctaPhone: 'Phone Inquiry',
    ctaPhoneNumber: '0532-55566163/55566165',
    viewTests: 'View Test Items',
    applicableStandards: 'Applicable Standards',
    features: [
      { title: 'ISO/IEC 17025 Certified', description: 'Internationally recognized accredited laboratory', icon: 'ri-award-line' },
      { title: 'Latest Testing Equipment', description: 'Precision testing through advanced analytical equipment', icon: 'ri-microscope-line' },
      { title: 'Professional Staff', description: 'Experienced professional testing personnel', icon: 'ri-team-line' },
      { title: 'Rapid Processing', description: 'Fast testing and result delivery', icon: 'ri-time-line' }
    ],
    processSteps: [
      { step: '01', title: 'Inquiry Reception', description: 'Confirm product information and testing requirements', icon: 'ri-customer-service-line' },
      { step: '02', title: 'Quotation', description: 'Detailed quotation guidance by test item', icon: 'ri-file-list-line' },
      { step: '03', title: 'Sample Reception', description: 'Receive samples and prepare for testing', icon: 'ri-inbox-line' },
      { step: '04', title: 'Testing', description: 'Precision testing using professional equipment', icon: 'ri-flask-line' },
      { step: '05', title: 'Result Issuance', description: 'Issue test report and deliver', icon: 'ri-file-text-line' }
    ],
    categories: [
      {
        id: 'jewelry',
        name: 'Jewelry',
        description: 'Verifying quality and safety of precious metals and gemstones',
        tests: [
          { category: 'Composition Analysis', items: ['Precious Metal Purity Analysis', 'Alloy Composition Analysis', 'Plating Thickness Measurement', 'Gemstone Appraisal'] },
          { category: 'Hazardous Substance Inspection', items: ['Lead (Pb)', 'Cadmium (Cd)', 'Nickel Release', 'Hexavalent Chromium'] },
          { category: 'Physical Testing', items: ['Abrasion Resistance', 'Corrosion Resistance', 'Plating Adhesion', 'Tensile Strength'] }
        ],
        standards: ['US CPSC/CPSIA', 'US State Law', 'EU REACH', 'GB', 'KC', 'SAH Certification Standards', '925 Silver', 'Precious Metal Labeling Regulations']
      },
      {
        id: 'children',
        name: 'Children\'s Products',
        description: 'Thoroughly inspecting safety and quality of children\'s products',
        tests: [
          { category: 'Physical Safety', items: ['Small Parts', 'Sharp Edges', 'Drop Test', 'Compression Test', 'Tensile Test', 'Torsion Test'] },
          { category: 'Chemical Safety', items: ['8 Heavy Metals', '6 Phthalates', 'Azo Dyes', 'BPA', 'Formaldehyde'] },
          { category: 'Flammability Testing', items: ['Textile Flammability', 'Plastic Flammability'] }
        ],
        standards: ['ASTM F963', 'EN 71', 'GB 6675', 'CPSIA', 'ISO 8124']
      },
      {
        id: 'baby',
        name: 'Baby Products',
        description: 'Prioritizing safety verification of infant products',
        tests: [
          { category: 'Physical Safety', items: ['Choking Hazard', 'Sharp Parts', 'Pinch Hazard', 'Stability Test'] },
          { category: 'Chemical Safety', items: ['Heavy Metals', 'Phthalates', 'BPA', 'Formaldehyde', 'VOCs'] },
          { category: 'Microbial Testing', items: ['Total Aerobic Count', 'Coliform Group', 'Staphylococcus Aureus', 'Pseudomonas Aeruginosa'] }
        ],
        standards: ['ASTM F2194', 'EN 14372', 'GB 28482', 'CPSIA', 'FDA']
      },
      {
        id: 'stationery',
        name: 'Stationery Products',
        description: 'Evaluating safety and quality of student stationery',
        tests: [
          { category: 'Chemical Safety', items: ['8 Heavy Metals', 'Aromatic Amines', 'Phthalates', 'Formaldehyde'] },
          { category: 'Physical Safety', items: ['Sharp Edges', 'Cap Safety', 'Pen Tip Safety'] },
          { category: 'Performance Testing', items: ['Writing Performance', 'Eraser Performance', 'Adhesion', 'Water Resistance'] }
        ],
        standards: ['EN 71-3', 'ASTM D4236', 'GB 21027', 'ISO 11540']
      },
      {
        id: 'hygiene',
        name: 'Hygiene Products',
        description: 'Verifying safety and efficacy of hygiene products',
        tests: [
          { category: 'Microbial Testing', items: ['Total Aerobic Count', 'E. Coli', 'Pseudomonas Aeruginosa', 'Staphylococcus Aureus', 'Mold'] },
          { category: 'Chemical Safety', items: ['Heavy Metals', 'Methanol', 'Formaldehyde', 'Preservatives', 'pH'] },
          { category: 'Efficacy Testing', items: ['Antibacterial Effect', 'Bactericidal Effect', 'Cleaning Power'] }
        ],
        standards: ['GB 15979', 'ISO 22196', 'ASTM E2149', 'FDA']
      },
      {
        id: 'safety',
        name: 'Safety Products',
        description: 'Evaluating safety and performance of personal protective equipment',
        tests: [
          { category: 'Physical Performance', items: ['Impact Absorption', 'Penetration Resistance', 'Tensile Strength', 'Abrasion Resistance'] },
          { category: 'Chemical Safety', items: ['Hazardous Substances', 'pH', 'Skin Irritation'] },
          { category: 'Functional Testing', items: ['Water Resistance', 'Breathability', 'Flame Retardancy', 'Heat Resistance'] }
        ],
        standards: ['EN 420', 'ANSI Z87.1', 'EN 388', 'ISO 20345', 'GB 2626']
      },
      {
        id: 'textile',
        name: 'Textile Products',
        description: 'Comprehensively evaluating quality and safety of textile products',
        tests: [
          { category: 'Chemical Safety', items: ['Azo Dyes', 'Formaldehyde', 'pH', 'Heavy Metals', 'Allergenic Dyes', 'DMFu'] },
          { category: 'Physical Performance', items: ['Tensile Strength', 'Tear Strength', 'Abrasion Resistance', 'Pilling Test', 'Dimensional Change'] },
          { category: 'Functional Testing', items: ['Wash Fastness', 'Perspiration Fastness', 'Rubbing Fastness', 'Light Fastness', 'Water Resistance', 'Breathability'] },
          { category: 'Flammability Testing', items: ['Textile Flammability', 'Flame Retardancy Evaluation'] }
        ],
        standards: ['OEKO-TEX Standard 100', 'GB 18401', 'REACH', 'CPSIA', 'EN 14682', 'ASTM D4966', 'ISO 105']
      },
      {
        id: 'electrical',
        name: 'Home Electrical Appliances',
        description: 'Verifying electrical safety and performance of home appliances',
        tests: [
          { category: 'Electrical Safety', items: ['Insulation Resistance', 'Withstand Voltage', 'Ground Continuity', 'Leakage Current', 'Temperature Rise'] },
          { category: 'Mechanical Safety', items: ['Structure Inspection', 'Mechanical Strength', 'Stability Test', 'Drop Test'] },
          { category: 'Chemical Safety', items: ['Hazardous Substances (RoHS)', 'Flame Retardancy', 'PAHs', 'Phthalates'] },
          { category: 'EMC Testing', items: ['Electromagnetic Compatibility', 'Electromagnetic Emission', 'Electromagnetic Immunity'] }
        ],
        standards: ['IEC 60335', 'GB 4706', 'UL 1026', 'EN 60335', 'KC Certification', 'CE Certification', 'RoHS', 'REACH']
      },
      {
        id: 'game',
        name: 'Games',
        description: 'Evaluating safety and quality of game products',
        tests: [
          { category: 'Physical Safety', items: ['Small Parts', 'Sharp Edges', 'Drop Test', 'Compression Test'] },
          { category: 'Chemical Safety', items: ['Heavy Metals', 'Phthalates', 'PAHs', 'Azo Dyes'] }
        ],
        standards: ['ASTM F963', 'EN 71', 'GB 6675', 'CPSIA']
      },
      {
        id: 'silver',
        name: 'Silver Products',
        description: 'Verifying purity and quality of Silver products',
        tests: [
          { category: 'Composition Analysis', items: ['Silver Purity Analysis', 'Alloy Composition Analysis', 'Plating Analysis'] },
          { category: 'Hazardous Substance Inspection', items: ['Lead (Pb)', 'Cadmium (Cd)', 'Nickel Release', 'Heavy Metals'] },
          { category: 'Physical Testing', items: ['Abrasion Resistance', 'Corrosion Resistance', 'Plating Adhesion'] }
        ],
        standards: ['925 Silver', 'US CPSC', 'EU REACH', 'GB', 'KC']
      },
      {
        id: 'furniture',
        name: 'Indoor Furniture Products',
        description: 'Evaluating safety and durability of indoor furniture',
        tests: [
          { category: 'Physical Safety', items: ['Stability Test', 'Durability Test', 'Drop Test', 'Load Test'] },
          { category: 'Chemical Safety', items: ['Formaldehyde', 'VOCs', 'Heavy Metals', 'Flame Retardancy'] },
          { category: 'Material Testing', items: ['Wood Strength', 'Adhesive Performance', 'Surface Finish', 'Abrasion Resistance'] }
        ],
        standards: ['EN 12520', 'BIFMA', 'GB 28007', 'CARB', 'REACH']
      },
      {
        id: 'packaging',
        name: 'Packaging (Internal & External)',
        description: 'Verifying safety and performance of packaging materials',
        tests: [
          { category: 'Physical Testing', items: ['Compression Strength', 'Drop Test', 'Vibration Test', 'Impact Test'] },
          { category: 'Chemical Safety', items: ['Heavy Metals', 'Phthalates', 'PAHs', 'Food Contact Substances'] },
          { category: 'Performance Testing', items: ['Water Resistance', 'Heat Resistance', 'Sealing Performance', 'Print Quality'] }
        ],
        standards: ['ISTA', 'ASTM D4169', 'ISO 12048', 'GB/T 4857', 'FDA', 'EU 10/2011']
      }
    ]
  },

  // Jewelry Technical Center Page
  jewelryCenter: {
    badge: 'Technical Center (Subsidiary)',
    title: 'Jewelry Technical Center',
    subtitle: 'Professional technical support center for quality assurance and safety of precious metals and gemstone products',
    servicesTitle: 'Professional Testing Services',
    servicesSubtitle: 'Comprehensive testing and analysis services specialized for the jewelry industry',
    equipmentTitle: 'Professional Equipment',
    equipmentSubtitle: 'Accurate test results with state-of-the-art analytical equipment',
    ctaTitle: 'Need Jewelry Testing?',
    ctaDesc: 'Our expert team provides optimized testing solutions for your products',
    ctaButton: 'Contact Us',
    service1: {
      title: 'Precious Metal Purity Analysis',
      description: 'Accurate purity measurement of gold, silver, platinum, etc.',
      item1: 'Gold purity analysis (K unit)',
      item2: 'Silver purity analysis',
      item3: 'Platinum purity analysis',
      item4: 'Alloy composition analysis'
    },
    service2: {
      title: 'Gemstone Appraisal',
      description: 'Quality evaluation of diamonds and various gemstones',
      item1: 'Diamond 4C evaluation',
      item2: 'Color stone appraisal',
      item3: 'Pearl quality evaluation',
      item4: 'Synthetic stone identification'
    },
    service3: {
      title: 'Hazardous Substance Testing',
      description: 'Measurement of harmful substance content',
      item1: 'Nickel release test',
      item2: 'Cadmium testing',
      item3: 'Lead content analysis',
      item4: 'Chromium testing'
    },
    service4: {
      title: 'Physical Safety Testing',
      description: 'Durability and safety evaluation of products',
      item1: 'Sharp edge inspection',
      item2: 'Small parts test',
      item3: 'Tensile strength test',
      item4: 'Abrasion resistance test'
    },
    service5: {
      title: 'International Certification Support',
      description: 'Certification acquisition support for export',
      item1: 'REACH certification',
      item2: 'RoHS certification',
      item3: 'California Prop 65',
      item4: 'KC certification'
    },
    service6: {
      title: 'Quality Certificate Issuance',
      description: 'Providing credible quality certificates',
      item1: 'Purity certificate',
      item2: 'Appraisal certificate',
      item3: 'Test report',
      item4: 'Conformity certificate'
    },
    equipment: {
      icpms: 'Trace element analysis',
      xrf: 'Non-destructive composition analysis',
      uvvis: 'Gemstone spectral analysis',
      scale: 'Electronic Scale',
      scaleDesc: 'Precision weight measurement',
      hardness: 'Hardness Tester',
      hardnessDesc: 'Gemstone hardness measurement',
      microscope: 'Microscope',
      microscopeDesc: 'Microstructure observation',
      refractometer: 'Refractometer',
      refractometerDesc: 'Gemstone refractive index measurement',
      spectrometer: 'Spectrometer',
      spectrometerDesc: 'Color analysis'
    }
  },

  // Children Baby Technical Center Page
  childrenCenter: {
    badge: 'Technical Center (Subsidiary)',
    title: 'Children & Baby Products Technical Center',
    subtitle: 'Professional testing and technical support center prioritizing child and infant safety',
    servicesTitle: 'Professional Testing Services',
    servicesSubtitle: 'Comprehensive testing services for children/baby product safety evaluation',
    productsTitle: 'Test Target Products',
    productsSubtitle: 'Professional testing services for various children/baby products',
    standardsTitle: 'Applicable Standards',
    standardsSubtitle: 'Compliance with major domestic and international safety standards',
    ctaTitle: 'Need Children/Baby Product Testing?',
    ctaDesc: 'We provide professional testing services for child safety',
    ctaButton: 'Contact Us',
    service1: {
      title: 'Physical Safety Testing',
      description: 'Evaluation of physical hazards in products',
      item1: 'Sharp edge inspection',
      item2: 'Small parts test',
      item3: 'Tensile strength test',
      item4: 'Compression test'
    },
    service2: {
      title: 'Chemical Safety Testing',
      description: 'Measurement of hazardous chemical content',
      item1: 'Phthalate testing',
      item2: 'Heavy metal analysis',
      item3: 'BPA testing',
      item4: 'Formaldehyde measurement'
    },
    service3: {
      title: 'Flammability Testing',
      description: 'Fire safety evaluation of products',
      item1: 'Textile flammability test',
      item2: 'Plastic flammability test',
      item3: 'Toy flammability test',
      item4: 'Flame retardancy evaluation'
    },
    service4: {
      title: 'Microbial Testing',
      description: 'Hygiene and microbial safety evaluation',
      item1: 'Total bacterial count',
      item2: 'E. coli testing',
      item3: 'Mold testing',
      item4: 'Salmonella testing'
    },
    service5: {
      title: 'International Certification Support',
      description: 'Support for domestic and international safety certification',
      item1: 'KC certification',
      item2: 'EN 71',
      item3: 'ASTM F963',
      item4: 'CPSIA'
    },
    service6: {
      title: 'Product Improvement Consulting',
      description: 'Expert consulting for safety improvement',
      item1: 'Design improvement suggestions',
      item2: 'Material selection advice',
      item3: 'Standard compliance review',
      item4: 'After-sales support'
    },
    product1: 'Toys',
    product2: 'Baby Clothing',
    product3: 'Strollers',
    product4: 'Car Seats',
    product5: 'Bottles/Nipples',
    product6: 'Diapers',
    product7: 'Bedding',
    product8: 'School Supplies',
    product9: 'Play Equipment',
    product10: 'Safety Products',
    product11: 'Tableware',
    product12: 'Bath Products',
    region: {
      korea: 'Korea',
      europe: 'Europe',
      usa: 'USA',
      china: 'China',
      international: 'International',
      japan: 'Japan',
      taiwan: 'Taiwan'
    },
    standard1: 'Children\'s Product Safety Special Act',
    standard2: 'Toy Safety Standard',
    standard3: 'Toy Safety Standard',
    standard4: 'Consumer Product Safety Improvement Act',
    standard5: 'Toy Safety Technical Specification',
    standard6: 'Toy Safety International Standard',
    standard7: 'Japanese Industrial Standards',
    standard8: 'Chinese National Standards'
  },

  // Education Center Page
  educationCenter: {
    badge: 'Customer Support',
    title: 'Education Center',
    subtitle: 'Systematic education programs for training product safety and quality management experts',
    programsTitle: 'Education Programs',
    programsSubtitle: 'Practice-oriented professional training courses',
    benefitsTitle: 'Education Benefits',
    benefitsSubtitle: 'Various benefits for expertise enhancement and career development',
    mainContent: 'Main Content',
    ctaTitle: 'Education Inquiry',
    ctaDesc: 'We provide customized education programs tailored to your training requirements',
    ctaButton: 'Apply for Education',
    level: {
      beginner: 'Beginner',
      intermediate: 'Intermediate',
      advanced: 'Advanced'
    },
    program1: {
      title: 'Quality Management Basics',
      duration: '2 days (16 hours)',
      description: 'Basic concepts and practical application of quality management',
      topic1: 'Introduction to Quality Management',
      topic2: 'Statistical Quality Control',
      topic3: 'Inspection and Testing Methods',
      topic4: 'Defect Analysis Techniques'
    },
    program2: {
      title: 'Product Safety Standards',
      duration: '3 days (24 hours)',
      description: 'Understanding and application of domestic and international product safety standards',
      topic1: 'KC Certification System',
      topic2: 'EN 71 Standards',
      topic3: 'ASTM Standards',
      topic4: 'CPSIA Regulations'
    },
    program3: {
      title: 'Chemical Testing Analysis',
      duration: '5 days (40 hours)',
      description: 'Chemical testing methods and analysis techniques',
      topic1: 'ICP-MS Analysis',
      topic2: 'GC-MS Analysis',
      topic3: 'HPLC Analysis',
      topic4: 'Sample Preparation'
    },
    program4: {
      title: 'Physical Testing Evaluation',
      duration: '3 days (24 hours)',
      description: 'Physical testing methods and evaluation techniques',
      topic1: 'Mechanical Testing',
      topic2: 'Flammability Testing',
      topic3: 'Durability Testing',
      topic4: 'Environmental Testing'
    },
    program5: {
      title: 'ISO 17025 Auditor Course',
      duration: '5 days (40 hours)',
      description: 'Laboratory accreditation system and audit techniques',
      topic1: 'ISO 17025 Requirements',
      topic2: 'Internal Audit Techniques',
      topic3: 'Corrective Actions',
      topic4: 'Document Management'
    },
    program6: {
      title: 'Test Report Writing',
      duration: '2 days (16 hours)',
      description: 'Professional test report writing methods',
      topic1: 'Report Structure',
      topic2: 'Data Analysis',
      topic3: 'Result Interpretation',
      topic4: 'Uncertainty Evaluation'
    },
    benefit1: {
      title: 'Certificate Issuance',
      desc: 'Accredited training certificate provided'
    },
    benefit2: {
      title: 'Expert Lectures',
      desc: 'Lectures by experts with field experience'
    },
    benefit3: {
      title: 'Training Materials',
      desc: 'Practical training materials provided'
    },
    benefit4: {
      title: 'After Support',
      desc: 'Continuous technical support after training'
    }
  },

  // Regulation Research Page
  regulationResearch: {
    badge: 'Customer Support',
    title: 'Regulation Research/Standard Development',
    subtitle: 'Supporting corporate competitiveness through domestic and international regulation research and industry standard development',
    servicesTitle: 'Main Services',
    servicesSubtitle: 'Professional services for regulation research and standard development',
    areasTitle: 'Research Areas',
    areasSubtitle: 'Regulation and standard research across various industry sectors',
    benefitsTitle: 'Expected Benefits',
    benefitsSubtitle: 'Enhancing corporate value through regulation research and standard development',
    ctaTitle: 'Regulation Research & Standard Development Inquiry',
    ctaDesc: 'Our expert team supports your regulatory response and standardization strategy',
    ctaButton: 'Contact Us',
    service1: {
      title: 'Regulation Research & Analysis',
      description: 'Systematic research and analysis of domestic and international product safety regulations',
      item1: 'Domestic regulation monitoring and analysis',
      item2: 'International regulatory trend research',
      item3: 'Regulation amendment impact assessment',
      item4: 'Regulatory response strategy development',
      item5: 'Regulation interpretation and consulting'
    },
    service2: {
      title: 'Industry Standard Development',
      description: 'Standard and specification development for industry advancement',
      item1: 'KS standard development support',
      item2: 'Association standard establishment',
      item3: 'Test method standardization',
      item4: 'Quality criteria setting',
      item5: 'Standard dissemination and education'
    },
    service3: {
      title: 'International Standard Response',
      description: 'Professional response to international standards and specifications',
      item1: 'ISO/IEC standard research',
      item2: 'ASTM specification analysis',
      item3: 'EN specification response',
      item4: 'International standardization activity participation',
      item5: 'Overseas certification support'
    },
    service4: {
      title: 'Regulatory Compliance Assessment',
      description: 'Comprehensive assessment of product regulation and standard compliance',
      item1: 'Regulation compliance review',
      item2: 'Standard compliance evaluation',
      item3: 'Improvement recommendations',
      item4: 'Certification acquisition support',
      item5: 'After-sales management consulting'
    },
    area1: {
      title: 'Children/Baby Products',
      desc: 'Toy and children\'s product safety regulations'
    },
    area2: {
      title: 'Jewelry',
      desc: 'Precious metal and gemstone quality standards'
    },
    area3: {
      title: 'Textile/Apparel',
      desc: 'Textile product safety and quality standards'
    },
    area4: {
      title: 'Cosmetics',
      desc: 'Cosmetic safety standards and labeling regulations'
    },
    area5: {
      title: 'Food',
      desc: 'Food safety management and labeling standards'
    },
    area6: {
      title: 'Electronics/Electrical',
      desc: 'Electrical product safety management regulations'
    },
    benefit1: {
      title: 'Minimize Regulatory Risk',
      desc: 'Prevent risks from regulation violations'
    },
    benefit2: {
      title: 'Accelerate Market Entry',
      desc: 'Shorten market entry with rapid certification'
    },
    benefit3: {
      title: 'Strengthen Competitiveness',
      desc: 'Secure market competitiveness through standard leadership'
    },
    benefit4: {
      title: 'Support Global Expansion',
      desc: 'Expand exports through international standard compliance'
    }
  },

  certification: {
    companyName: 'Qingdao Testing Technology Service Co., Ltd.',
    backToHome: 'Back to Home',
    badge: 'Main Business',
    title: 'Certification Business/Certification Marks',
    subtitle: 'Supporting acquisition of essential certifications and certification marks required for global market entry. Providing various international certification services including CCC, CE, FCC, UL, etc.',
    servicesTitle: 'Main Certification Services',
    servicesSubtitle: 'Providing certification services that meet regulatory requirements of each country',
    processingPeriod: 'Processing Period',
    validityPeriod: 'Validity Period',
    viewDetails: 'View Details',
    applicableProducts: 'Applicable Products',
    certificationProcess: 'Certification Process',
    benefitsTitle: 'Benefits of Certification',
    benefitsSubtitle: 'Various benefits obtainable through international certification',
    benefits: [
      {
        title: 'Easy Market Entry',
        description: 'Meet regulatory requirements of each country to enter global markets',
        icon: 'ri-global-line'
      },
      {
        title: 'Enhanced Credibility',
        description: 'Prove product quality and safety through international certification',
        icon: 'ri-shield-check-line'
      },
      {
        title: 'Competitive Advantage',
        description: 'Certified products gain higher competitiveness in the market',
        icon: 'ri-trophy-line'
      },
      {
        title: 'Regulatory Compliance',
        description: 'Comply with regulations of each country to minimize legal risks',
        icon: 'ri-file-shield-line'
      }
    ],
    processTitle: 'Certification Process',
    processSubtitle: 'Supporting fast and accurate certification acquisition through systematic certification procedures',
    processSteps: [
      {
        step: '01',
        title: 'Consultation & Quotation',
        description: 'Confirm product and certification requirements',
        icon: 'ri-customer-service-line'
      },
      {
        step: '02',
        title: 'Contract & Application',
        description: 'Sign certification contract and submit application',
        icon: 'ri-file-text-line'
      },
      {
        step: '03',
        title: 'Testing',
        description: 'Product sample testing and evaluation',
        icon: 'ri-flask-line'
      },
      {
        step: '04',
        title: 'Factory Audit',
        description: 'On-site factory audit (if required)',
        icon: 'ri-building-line'
      },
      {
        step: '05',
        title: 'Certificate Issuance',
        description: 'Certificate issuance and mark usage approval',
        icon: 'ri-award-line'
      }
    ],
    certifications: [
      {
        id: 'ccc',
        name: 'CCC Certification',
        fullName: 'China Compulsory Certification',
        country: 'China',
        description: 'System Certification',
        products: ['Electrical and Electronic Products', 'Automotive Parts', 'Safety Glass', 'Fire Protection Products', 'Wireless Communication Equipment', 'Information Technology Equipment'],
        process: ['Application Submission and Contract', 'Product Sample Testing', 'Factory Audit', 'Certificate Issuance', 'Post-Management'],
        period: '60-90 days',
        validity: '5 years'
      },
      {
        id: 'ce',
        name: 'CE Mark',
        fullName: 'Conformité Européenne',
        country: 'European Union',
        description: 'SAH Safety and Hygiene Mark',
        products: ['Electrical and Electronic Products', 'Machinery', 'Medical Devices', 'Toys', 'Personal Protective Equipment', 'Construction Materials'],
        process: ['Applicable Directive Confirmation', 'Conformity Assessment', 'Technical Documentation Preparation', 'CE Mark Affixing', 'Declaration of Conformity Preparation'],
        period: '30-60 days',
        validity: 'Until product change'
      },
      {
        id: 'fcc',
        name: 'FCC Certification',
        fullName: 'Federal Communications Commission',
        country: 'United States',
        description: 'Quality Assurance Mark',
        products: ['Wireless Communication Equipment', 'Computers and Peripherals', 'Home Appliances', 'LED Lighting', 'Industrial Electronic Equipment'],
        process: ['Product Classification Confirmation', 'EMC Testing', 'Certificate Application', 'FCC ID Issuance', 'Label Affixing'],
        period: '20-40 days',
        validity: 'Permanent'
      },
      {
        id: 'system',
        name: 'System Certification',
        fullName: 'Management System Certification',
        country: 'International',
        description: 'HSPM, Automotive, Social Responsibility SA8000, ISO 9000/ISO 14000',
        products: ['HSPM (Hazard Analysis Critical Control Point)', 'Automotive Industry', 'SA8000 (Social Accountability)', 'ISO 9000 (Quality Management)', 'ISO 14000 (Environmental Management)', 'Integrated Management System'],
        process: ['Management System Establishment', 'Documentation Work', 'Internal Audit', 'Certification Audit', 'Certificate Issuance'],
        period: '90-120 days',
        validity: '3 years (annual follow-up audit)'
      },
      {
        id: 'sah',
        name: 'SAH Safety and Hygiene Mark',
        fullName: 'Safety And Hygiene Mark',
        country: 'International',
        description: 'Jewelry/Precious Metals/Gems, Daily Products, Silver Products, Hygiene Products, Personal Safety Protection Equipment',
        products: ['Jewelry/Precious Metals/Gems', 'Daily Products', 'Silver Products', 'Hygiene Products', 'Personal Safety Protection Equipment', 'Household Products'],
        process: ['Product Safety Assessment', 'Hygiene Testing', 'Hazardous Substance Inspection', 'Quality Verification', 'Certificate Issuance'],
        period: '30-60 days',
        validity: '2 years'
      },
      {
        id: 'quality',
        name: 'Quality Assurance Mark',
        fullName: 'Quality Assurance Mark',
        country: 'International',
        description: 'Precious Metals/Gems Quality Assurance',
        products: ['Precious Metal Products', 'Gems', 'Diamonds', 'Gold/Silver Products', 'Pearls', 'Luxury Jewelry'],
        process: ['Composition Analysis', 'Quality Inspection', 'Purity Measurement', 'Appraisal Certificate Issuance', 'Quality Assurance Certificate Issuance'],
        period: '15-30 days',
        validity: 'Permanent'
      },
      {
        id: 'ul',
        name: 'UL Certification',
        fullName: 'Underwriters Laboratories',
        country: 'United States',
        description: 'US product safety certification organization, recognized worldwide as a safety mark.',
        products: ['Electrical and Electronic Products', 'Fire Safety Products', 'Industrial Equipment', 'Medical Devices', 'Construction Materials', 'Home Appliances'],
        process: ['Product Evaluation Application', 'Sample Testing', 'Factory Audit', 'UL Mark Approval', 'Regular Factory Audit'],
        period: '60-90 days',
        validity: 'Annual renewal'
      },
      {
        id: 'rohs',
        name: 'RoHS Certification',
        fullName: 'Restriction of Hazardous Substances',
        country: 'European Union',
        description: 'Directive restricting the use of hazardous substances in electrical and electronic products.',
        products: ['Electrical and Electronic Products', 'Home Appliances', 'Lighting Equipment', 'Toys', 'Medical Devices', 'Monitoring Equipment'],
        process: ['Product Analysis', 'Hazardous Substance Testing', 'Conformity Assessment', 'Certificate Issuance', 'Technical Documentation Preparation'],
        period: '15-30 days',
        validity: 'Until product change'
      },
      {
        id: 'reach',
        name: 'REACH Certification',
        fullName: 'Registration, Evaluation, Authorization of Chemicals',
        country: 'European Union',
        description: 'EU regulation on registration, evaluation, authorization and restriction of chemicals.',
        products: ['Chemicals', 'Textile Products', 'Electrical and Electronic Products', 'Toys', 'Furniture', 'Packaging Materials'],
        process: ['SVHC Confirmation', 'Chemical Analysis', 'Conformity Assessment', 'Report Preparation', 'Certificate Issuance'],
        period: '20-40 days',
        validity: '1 year'
      },
      {
        id: 'cpsia',
        name: 'CPSIA Certification',
        fullName: 'Consumer Product Safety Improvement Act',
        country: 'United States',
        description: 'US Consumer Product Safety Improvement Act, safety standards for children\'s products.',
        products: ['Children\'s Toys', 'Baby Products', 'Children\'s Clothing', 'School Supplies', 'Children\'s Furniture', 'Children\'s Accessories'],
        process: ['Product Testing', 'Lead Content Inspection', 'Phthalate Inspection', 'CPC Certificate Preparation', 'Label Affixing'],
        period: '15-30 days',
        validity: 'Until product change'
      },
      {
        id: 'astm',
        name: 'ASTM F963',
        fullName: 'American Society for Testing and Materials',
        country: 'United States',
        description: 'US toy safety standard that evaluates physical and chemical safety of toys.',
        products: ['Toys', 'Games', 'Puzzles', 'Dolls', 'Sports Toys', 'Educational Toys'],
        process: ['Physical Testing', 'Chemical Testing', 'Flammability Testing', 'Conformity Assessment', 'Certificate Issuance'],
        period: '20-40 days',
        validity: 'Until product change'
      }
    ],
    ctaTitle: 'Need Certification Consultation?',
    ctaDesc: 'Professional consultants will guide you on the optimal certification method for your product.',
    ctaButton1: 'Online Inquiry',
    ctaPhone: 'Phone Inquiry',
    ctaPhoneNumber: '0532-55566163/55566165'
  },

  certificationSupport: {
    badge: 'Customer Support',
    title: 'Certification System Support (By Field)',
    subtitle: 'Providing professional consulting and testing services for domestic and international certification systems by field',
    backToHome: 'Back to Home',
    processTitle: 'Certification Support Process',
    processSubtitle: 'Supporting certification acquisition through systematic processes',
    ctaTitle: 'Have certification-related inquiries?',
    ctaDesc: 'Professional consultants will guide you on the certifications needed for your products',
    ctaButton: 'Contact for Consultation',
    processSteps: [
      { step: '1', title: 'Consultation & Analysis', desc: 'Analysis of products and certification requirements', icon: 'ri-discuss-line' },
      { step: '2', title: 'Test Planning', desc: 'Establishment of required test items and schedule', icon: 'ri-file-list-line' },
      { step: '3', title: 'Test Execution', desc: 'Precision testing according to international standards', icon: 'ri-test-tube-line' },
      { step: '4', title: 'Report Issuance', desc: 'Preparation of test result reports', icon: 'ri-file-text-line' },
      { step: '5', title: 'Certification Support', desc: 'Submission to certification bodies and post-management', icon: 'ri-award-line' }
    ],
    certifications: {
    children: {
        title: 'Children/Baby Products Certification',
        description: 'Domestic and international certification support ensuring safety of children and infants',
        standards: [
          { name: 'KC Certification', desc: 'Korea Children\'s Product Safety Special Act Certification' },
          { name: 'EN 71', desc: 'European Toy Safety Standard' },
          { name: 'ASTM F963', desc: 'US Toy Safety Standard' },
          { name: 'CPSIA', desc: 'US Consumer Product Safety Improvement Act' },
          { name: 'GB 6675', desc: 'China Toy Safety Technical Specification' }
        ]
      },
      jewelry: {
        title: 'Jewelry Certification',
        description: 'Certification ensuring quality and safety of precious metals and gemstones',
        standards: [
          { name: 'KC Certification', desc: 'Korea Precious Metals and Gem Quality Certification' },
          { name: 'REACH', desc: 'European Chemical Regulation' },
          { name: 'RoHS', desc: 'Restriction of Hazardous Substances Directive' },
          { name: 'California Prop 65', desc: 'California Hazardous Substance Warning Regulation' },
          { name: 'Nickel Release', desc: 'Nickel Release Test' }
        ]
    },
    textile: {
        title: 'Textile/Apparel Certification',
        description: 'International standard certifying safety and quality of textile products',
        standards: [
          { name: 'Oeko-Tex Standard 100', desc: 'Hazardous Substance Testing Certification' },
          { name: 'GOTS', desc: 'Global Organic Textile Standard Certification' },
          { name: 'REACH', desc: 'European Chemical Regulation' },
          { name: 'KC Certification', desc: 'Korea Textile Product Quality Certification' },
          { name: 'CPSIA', desc: 'US Consumer Product Safety Act' }
        ]
    },
    cosmetics: {
        title: 'Cosmetics Certification',
        description: 'Certification system verifying safety and efficacy of cosmetics',
        standards: [
          { name: 'ISO 22716', desc: 'Cosmetics GMP International Standard' },
          { name: 'CPNP', desc: 'European Cosmetics Notification Portal' },
          { name: 'FDA Registration', desc: 'US Food and Drug Administration Registration' },
          { name: 'CFDA', desc: 'China Food and Drug Administration Certification' },
          { name: 'KC Certification', desc: 'Korea Cosmetics Safety Standard' }
        ]
    },
    food: {
        title: 'Food Certification',
        description: 'Certification system ensuring food safety and quality',
        standards: [
          { name: 'HACCP', desc: 'Food Safety Management Certification' },
          { name: 'ISO 22000', desc: 'Food Safety Management System' },
          { name: 'FSSC 22000', desc: 'Food Safety System Certification' },
          { name: 'Halal', desc: 'Halal Certification' },
          { name: 'Kosher', desc: 'Kosher Certification' }
        ]
    },
    electronics: {
        title: 'Electronics/Electrical Certification',
        description: 'International certification verifying safety and performance of electronic products',
        standards: [
          { name: 'CE Mark', desc: 'European Product Safety Certification' },
          { name: 'FCC', desc: 'US Federal Communications Commission Certification' },
          { name: 'RoHS', desc: 'Restriction of Hazardous Substances Directive' },
          { name: 'REACH', desc: 'European Chemical Regulation' },
          { name: 'KC Certification', desc: 'Korea Electronics Product Safety Certification' }
        ]
    },
    medical: {
        title: 'Medical Device Certification',
        description: 'Certification ensuring safety and efficacy of medical devices',
        standards: [
          { name: 'ISO 13485', desc: 'Medical Device Quality Management System' },
          { name: 'CE Mark (MDR)', desc: 'European Medical Device Regulation' },
          { name: 'FDA 510(k)', desc: 'US Medical Device Premarket Notification' },
          { name: 'MFDS Certification', desc: 'Korea Food and Drug Safety Administration Certification' },
          { name: 'CFDA', desc: 'China Medical Device Registration' }
        ]
      },
      environmental: {
        title: 'Environmental Certification',
        description: 'International standard certifying eco-friendly products',
        standards: [
          { name: 'ISO 14001', desc: 'Environmental Management System Certification' },
          { name: 'Carbon Footprint', desc: 'Carbon Footprint Certification' },
          { name: 'FSC', desc: 'Forest Stewardship Council Certification' },
          { name: 'Energy Star', desc: 'Energy Efficiency Certification' },
          { name: 'Environmental Label', desc: 'Korea Environmental Label Certification' }
        ]
      }
    },
    standardsTitle: 'Main Certification Standards'
  }
};
